export default __webpack_public_path__ + "static/media/greeting13.aceed6e6.png";